// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Decisions_pageContent__RHHiL"};